import { Stack, Typography, Button, Box } from "@mui/material";
import warning_icon from "../../../assets/images/Icons/icAlert.svg";
import { CustomeDialog } from "../../../shared";

export const MoveToDraftDialog = ({ open, onConfirm, onCancel }) => {
  return (
    <CustomeDialog
      title={
        <Stack direction="row" gap="10px" alignItems="center" p="24px" pb="8px">
          <Box
            sx={{
              width: "30px",
              height: "30px",
              borderRadius: "35px",
              bgcolor: "#F044381F",
            }}
          >
            <img
              src={warning_icon}
              style={{ padding: "6px" }}
              alt="move-to-draft"
            />
          </Box>
          <Typography fontWeight={500} variant="body1" fontSize="20px">
            Move stocktake back to Draft?
          </Typography>
        </Stack>
      }
      open={open}
      divider={false}
      content={
        <Typography variant="body1">
          This stocktake is already finalized.
          <br />
          Moving it back to Draft will allow edits and may change reported stock
          values.
        </Typography>
      }
      footer={{
        display: true,
        cancelButton: "Cancel",
        confirmButton: (
          <Button variant="contained" size="small" onClick={onConfirm}>
            Move to Draft
          </Button>
        ),
        onConfirm: true,
        onCancel,
      }}
      sx={{
        pt: "16px",
        px: "24px",
        pb: "8px",
        width: { md: "500px", sm: "400px", xs: "90%" },
      }}
    />
  );
};
